import React,{useState, useEffect} from 'react'
import { useForm } from "react-hook-form";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { toast } from "react-toastify";
import api from '../../../api/api';



const AdminSearchCustomer = ({setUserId, user_type='CL'}) => {
    const [searchData, setSearchData] = useState([]);
   
    useEffect(() => {
        api
          .get(`/users/?user_type=${user_type}`)
          .then((response) => {
            // console.log(response.data)
            setSearchData(
              response.data.map(({ email: name, id }) => ({ name, id }))
            );
          })
          .catch((error) => {
            console.log(error);
          });
      }, []);




    const handleOnSearch = (string, results) => {
        // onSearch will have as the first callback parameter
        // the string searched and for the second the results.
        // console.log(string, results)
      };

    const handleOnHover = (result) => {
        // the item hovered
        // console.log(result)
    };

    const handleOnSelect = (item) => {
        
        setUserId(item.id)
       
      };

      const handleOnFocus = () => {
        // console.log('Focused')
      };

      const formatResult = (item) => {
        return (
          <>
            {/* <span style={{ display: 'block', textAlign: 'left' }}>id: {item.id}</span> */}
            <span style={{ display: "block", textAlign: "left" }}>{item.name}</span>
          </>
        );
      };
      



  return (
    <div className='md:w-[20rem] '>
    <ReactSearchAutocomplete
        items={searchData}
        onSearch={handleOnSearch}
        onHover={handleOnHover}
        onSelect={handleOnSelect}
        onFocus={handleOnFocus}
        autoFocus
        formatResult={formatResult}
        placeholder="Search User ........."
    
    />
      </div>
  )
}

export default AdminSearchCustomer